import { apiEndpoint } from "@/configs/api/api-configs";
import { reactive } from "@vue/composition-api";

export default function flashdealEntryModel() {
  const fetchFlashDealEntryList = reactive({
    api: `${apiEndpoint.bcrm_platform}/flashdeal/entry/list`,
    method: "POST",
    payload: {
      Campaign_Alt_Ref: null,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const fetchFlashDealEntryChangeStatus = reactive({
    api: `${apiEndpoint.bcrm_platform}/flashdeal/entry/Change_Status`,
    method: "POST",
    payload: {
      Campaign_Alt_Ref: null,
      Privilege_Alt_Ref: null,
      Inventory_Alt_Ref: null,
      Status: null,
    },
  });

  const fetchFlashDealEntryReorder = reactive({
    api: `${apiEndpoint.bcrm_platform}/flashdeal/entry/Reorder`,
    method: "POST",
    payload: {
      Campaign_Alt_Ref: null,
      Privilege_Alt_Ref: null,
      Inventory_Alt_Ref: null,
      From: null,
      To: null,
    },
  });

  const fetchFlashDealEntryDelete = reactive({
    api: `${apiEndpoint.bcrm_platform}/flashdeal/entry/Delete`,
    method: "POST",
    payload: {
      Campaign_Alt_Ref: null,
      Privilege_Alt_Ref: null,
      Inventory_Alt_Ref: null,
    },
  });

  const fetchFlashDealEntryDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/flashdeal/entry/Detail`,
    method: "POST",
    payload: {
      Campaign_Alt_Ref: null,
      Privilege_Alt_Ref: null,
      Inventory_Alt_Ref: null,
    },
  });

  const fetchFlashDealEntryEdit = reactive({
    api: `${apiEndpoint.bcrm_platform}/flashdeal/entry/Edit`,
    method: "POST",
    payload: {
      Campaign_Alt_Ref: null,
      Privilege_Alt_Ref: null,
      Inventory_Alt_Ref: null,
      Point : null
    },
  });

  return {
    fetchFlashDealEntryList,
    fetchFlashDealEntryChangeStatus,
    fetchFlashDealEntryReorder,
    fetchFlashDealEntryDelete,
    fetchFlashDealEntryDetail,
    fetchFlashDealEntryEdit
  };
}
